module.exports = __webpack_public_path__ + "static/media/400128_01.efadb3f1.png";